import React from 'react';

const LoadingIndicator = () => (
  <div id="preloader">
    <div id="status">&nbsp;</div>
  </div>
);

export default LoadingIndicator;
